import { render } from "./GameBoard.vue?vue&type=template&id=2809e588&scoped=true"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=2809e588&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2809e588"

export default script